import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Container,
  Chip
} from '@mui/material';
import { PersonAdd } from '@mui/icons-material';

const CustomerForm = () => {
  return (
    <Container maxWidth={false} disableGutters sx={{ py: 0, px: 0 }}>
      <Box textAlign="center" mb={4}>
        <PersonAdd sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
        <Typography variant="h3" component="h1" gutterBottom>
          Customer Management
        </Typography>
        <Typography variant="h5" color="text.secondary" gutterBottom>
          Comprehensive Customer Registration & Management System
        </Typography>
        <Chip 
          label="Coming Soon" 
          color="primary" 
          variant="outlined" 
          sx={{ mt: 2 }}
        />
      </Box>

      <Paper elevation={3} sx={{ p: 0 }}>
        <Typography variant="h4" gutterBottom>
          Module Overview
        </Typography>
        <Typography variant="body1" paragraph>
          The Customer Management module will provide a comprehensive solution for managing all customer information, 
          preferences, and interactions to enhance customer service and relationship management.
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 2 }}>
          Key Features:
        </Typography>
        <ul>
          <li>Add new customers with detailed information</li>
          <li>Manage customer preferences and requirements</li>
          <li>Track customer order history and patterns</li>
          <li>Manage customer communication and feedback</li>
          <li>Generate customer reports and analytics</li>
          <li>Customer loyalty and reward programs</li>
          <li>Integration with order management system</li>
          <li>Customer data import and export capabilities</li>
        </ul>
      </Paper>
    </Container>
  );
};

export default CustomerForm; 